(function () {
  "use strict";

  if (window.__tgcDyoAnalyticsLoaded) return;
  window.__tgcDyoAnalyticsLoaded = true;

  var ENTRY_CONTEXT_KEY = "tgc_dyo_entry_context";
  var ENTRY_CONTEXT_MAX_AGE_MS = 30 * 60 * 1000;
  var STEP_NAMES = {
    1: "container",
    2: "gift_items",
    3: "card_and_message",
    4: "custom_keepsake",
    5: "finishing_touch"
  };
  var root = null;
  var enteredAt = 0;
  var ready = false;
  var started = false;
  var viewedSteps = {};
  var debugEvents = [];

  window.__tgcDyoAnalytics = {
    events: debugEvents
  };

  function cleanValue(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
      var trimmed = value.trim();
      return trimmed ? trimmed.slice(0, 100) : undefined;
    }
    if (typeof value === "number") return Number.isFinite(value) ? value : undefined;
    if (typeof value === "boolean") return value;
    return undefined;
  }

  function deviceType() {
    if (window.matchMedia && window.matchMedia("(max-width: 767px)").matches) return "mobile";
    if (window.matchMedia && window.matchMedia("(max-width: 1023px)").matches) return "tablet";
    return "desktop";
  }

  function pagePath() {
    return (window.location.pathname || "/").toLowerCase();
  }

  function classifyEntryLocation(trigger, mode) {
    var explicit = trigger && trigger.closest("[data-tgc-entry-location]");
    var path = pagePath();

    if (explicit && explicit.dataset.tgcEntryLocation) return explicit.dataset.tgcEntryLocation;
    if (trigger && trigger.closest("header, nav, [role='navigation'], .shopify-section-header")) return "site_navigation";
    if (path === "/") return "homepage";
    if (path.indexOf("/pages/design-your-own") === 0) return "dyo_landing_page";
    if (path.indexOf("/collections/") === 0) return "collection_page";
    if (path.indexOf("/products/") === 0 && mode === "curated") return "curated_product_page";
    if (path.indexOf("/products/") === 0 && mode === "dyo") return "dyo_product_page";
    if (path.indexOf("/products/") === 0) return "product_page";
    return trigger ? "other_cta" : "direct_builder_entry";
  }

  function isDyoDestination(link) {
    if (!link || !link.href) return false;
    try {
      var destination = new URL(link.href, window.location.href);
      var destinationPath = destination.pathname.toLowerCase();
      return destinationPath.indexOf("/pages/design-your-own") === 0 ||
        destinationPath.indexOf("/collections/native-dyo-") === 0 ||
        destination.searchParams.get("view") === "tgc-dyo-builder";
    } catch (error) {
      return false;
    }
  }

  function storeEntryContext(location, mode) {
    try {
      window.sessionStorage.setItem(ENTRY_CONTEXT_KEY, JSON.stringify({
        location: location,
        mode: mode,
        capturedAt: Date.now()
      }));
    } catch (error) {
      return;
    }
  }

  function storedEntryLocation() {
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(ENTRY_CONTEXT_KEY) || "null");
      if (!stored || !stored.location || !stored.capturedAt) return undefined;
      if (Date.now() - stored.capturedAt > ENTRY_CONTEXT_MAX_AGE_MS) {
        window.sessionStorage.removeItem(ENTRY_CONTEXT_KEY);
        return undefined;
      }
      return stored.location;
    } catch (error) {
      return undefined;
    }
  }

  function builderContext(modeOverride, sourceOverride, locationOverride) {
    var mode = modeOverride || (root && root.dataset.builderMode) || "unknown";
    return {
      builder_mode: mode,
      builder_version: (root && root.dataset.builderVersion) || "tgc-1.0-native-dyo",
      entry_source: sourceOverride || (mode === "curated" ? "curated_product" : mode === "dyo" ? "dyo_product" : "unknown"),
      entry_location: locationOverride || storedEntryLocation() || classifyEntryLocation(null, mode),
      gateway_product_id: root && root.dataset.gatewayProductId,
      gateway_variant_id: root && root.dataset.gatewayVariantId,
      gateway_product_title: root && root.dataset.gatewayTitle,
      device_type: deviceType()
    };
  }

  function sendEvent(name, parameters) {
    var payload = {};
    var values = Object.assign({}, parameters || {});
    Object.keys(values).forEach(function (key) {
      var cleaned = cleanValue(values[key]);
      if (cleaned !== undefined) payload[key] = cleaned;
    });
    debugEvents.push({ name: name, parameters: Object.assign({}, payload), timestamp: Date.now() });
    if (debugEvents.length > 50) debugEvents.shift();
    if (root) {
      root.setAttribute("data-tgc-analytics-last-event", name);
      root.setAttribute("data-tgc-analytics-event-count", String(debugEvents.length));
    }

    if (typeof window.gtag === "function") {
      window.gtag("event", name, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      (function () {
        window.dataLayer.push(arguments);
      })("event", name, payload);
    }

    document.dispatchEvent(new CustomEvent("tgc:dyo-analytics-event", {
      detail: { name: name, parameters: Object.assign({}, payload) }
    }));
  }

  function markStarted() {
    if (started || !root || !ready) return;
    started = true;
    sendEvent("tgc_dyo_builder_started", builderContext());
  }

  function visibleStep() {
    if (!root) return;
    var panel = root.querySelector("[data-step-panel]:not([hidden])");
    if (!panel) return;
    var number = Number(panel.dataset.stepPanel || 0);
    if (!number || viewedSteps[number]) return;
    viewedSteps[number] = true;
    sendEvent("tgc_dyo_builder_step_viewed", Object.assign(builderContext(), {
      step_number: number,
      step_name: STEP_NAMES[number] || "unknown"
    }));
  }

  function installReadyTracking() {
    if (ready || !root || !root.classList.contains("is-catalog-ready")) return;
    ready = true;
    enteredAt = Date.now();
    sendEvent("tgc_dyo_builder_ready", builderContext());
    sendEvent("tgc_dyo_builder_entered", builderContext());
    visibleStep();

    root.addEventListener("input", markStarted, { capture: true, once: true });
    root.addEventListener("change", markStarted, { capture: true, once: true });
    root.addEventListener("click", function (event) {
      if (event.target.closest("[data-builder-exit]")) return;
      markStarted();
    }, { capture: true, once: true });

    var stepObserver = new MutationObserver(visibleStep);
    root.querySelectorAll("[data-step-panel]").forEach(function (panel) {
      stepObserver.observe(panel, { attributes: true, attributeFilter: ["hidden"] });
    });
  }

  function installBuilderTracking() {
    root = document.querySelector("[data-tgc-dyo-builder]");
    if (!root || root.dataset.analyticsInitialized === "true") return;
    root.dataset.analyticsInitialized = "true";

    if (!storedEntryLocation()) {
      storeEntryContext(classifyEntryLocation(null, root.dataset.builderMode), root.dataset.builderMode || "unknown");
    }

    sendEvent("tgc_dyo_builder_loaded", builderContext());
    installReadyTracking();
    if (!ready) {
      var readinessObserver = new MutationObserver(function () {
        installReadyTracking();
        if (ready) readinessObserver.disconnect();
      });
      readinessObserver.observe(root, { attributes: true, attributeFilter: ["class"] });
    }
  }

  document.addEventListener("click", function (event) {
    var curated = event.target.closest("[data-tgc-curated-gateway-link]");
    var dyo = event.target.closest("[data-tgc-dyo-launcher-link]");
    var link = event.target.closest("a[href]");
    if (!curated && !dyo && isDyoDestination(link)) dyo = link;
    if (!curated && !dyo) return;
    var mode = curated ? "curated" : "dyo";
    var entryLocation = classifyEntryLocation(curated || dyo, mode);
    storeEntryContext(entryLocation, mode);
    sendEvent("tgc_dyo_builder_cta_clicked", builderContext(mode, curated ? "curated_product" : "dyo_product", entryLocation));
  }, true);

  window.addEventListener("tgc:dyo-builder-completed", function (event) {
    var detail = event.detail || {};
    var elapsedSeconds = enteredAt ? Math.max(0, Math.round((Date.now() - enteredAt) / 1000)) : undefined;
    sendEvent("tgc_dyo_builder_completed", Object.assign(builderContext(detail.builderMode), {
      item_count: Number(detail.itemCount || 0) || undefined,
      elapsed_seconds: elapsedSeconds
    }));
  });

  window.addEventListener("tgc:dyo-builder-error", function (event) {
    var detail = event.detail || {};
    sendEvent("tgc_dyo_builder_error", Object.assign(builderContext(detail.builderMode), {
      error_stage: detail.errorStage || "unknown"
    }));
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", installBuilderTracking, { once: true });
  } else {
    installBuilderTracking();
  }
})();
